import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import socialIcons from '../utils/constants/socialIcons';

function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLabels = ['Facebook', 'X', 'YouTube', 'Discord', 'Instagram'];

  return (
    <footer className="footer-shell fixed-bottom border-top border-primary-orange-subtle shadow-sm py-2">
      <div className="container-fluid page-shell__inner px-3 px-lg-4">
        <div className="row g-2 align-items-center">
          <div className="col-12 col-lg-4 order-2 order-lg-1">
            <p className="footer-copy m-0 small text-center text-lg-start text-secondary text-capitalize sigmar-regular lh-sm">
              Follow <span className="text-primary-orange">SFB</span> socials for verified scene updates.
            </p>
          </div>

          <div className="col-12 col-lg-4 order-1 order-lg-2">
            <div className='d-flex justify-content-center align-items-center flex-wrap gap-3'>
              {socialIcons.map(({ icon, color, url, iconClassName = '' }, index) => (
                <a
                  key={`social-icon-${color}-${index}`}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit SFB on ${socialLabels[index] || 'Social'}`}
                  className="social-link text-decoration-none text-secondary opacity-75"
                >
                  <FontAwesomeIcon icon={icon} size="2x" style={{ color }} className={iconClassName} />
                </a>
              ))}
            </div>
          </div>

          <div className="col-12 col-lg-4 order-3">
            <p className='footer-contact m-0 text-center text-lg-end text-secondary anton-regular small opacity-75'>
              Closed Beta | {currentYear} | Contact&nbsp;
              <a href="mailto:support@spitfacebattles.com" className='text-accent text-decoration-none'>support@spitfacebattles.com</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;
